import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";

export type PlanType = 'zoo' | 'sanctuary' | 'collector';

export const usePlanType = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['plan-type', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase.rpc('get_user_plan_type');
      
      if (error) {
        console.error('Error fetching plan type:', error);
        return 'zoo' as PlanType; // Default fallback
      }
      
      return data as PlanType;
    },
    enabled: !!user?.id,
  });
};

export const useIsCollectorPlan = () => {
  const { data: planType, isLoading } = usePlanType();
  return {
    isCollector: planType === 'collector',
    isLoading,
  };
};

export const useFeatureFlag = (flagKey: string) => {
  return useQuery({
    queryKey: ['feature-flag', flagKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('public_settings')
        .select('value')
        .eq('key', flagKey)
        .maybeSingle();
      
      if (error) {
        console.error('Error fetching feature flag:', error);
        return false;
      }
      
      return data?.value === 'true';
    },
  });
};
